module.exports = __webpack_public_path__ + "static/media/OPEN_ACADEMY1.0c303a34.jpg";